import { EntityModel } from '@/interfaces'
import {
  ALL_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY,
  CREATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
  DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
  FORCE_DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
  SINGLE_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY,
  UPDATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
} from './graphql'
import tenantEntity from '@/entities/tenant/entity'

const availabilityStatusTenantSettingsModel: EntityModel = {
  name: 'availabilityStatusTenantSettings',
  namePlural: 'availabilityStatusTenantSettings',
  uniqueName: 'availabilityStatusTenantSettings',
  uniqueNamePlural: 'availabilityStatusTenantSettings',
  path: 'travel/availability_status_tenant_settings',
  baseUrl: '/travel/availability_status_tenant_settings',
  translationPrefix: 'entities:availabilityStatusTenantSettings.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY,
    getSingle: SINGLE_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY,
    create: CREATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
    update: UPDATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
    delete: DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
  },
  attributes: {
    tenant: {
      name: 'tenant',
      label: 'entities:availabilityStatusTenantSettings.attributes.tenant.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:availabilityStatusTenantSettings.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    info: {
      name: 'info',
      label: 'entities:availabilityStatusTenantSettings.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [],
    },
    switchToStatusInfo: {
      name: 'switchToStatusInfo',
      label: 'entities:availabilityStatusTenantSettings.attributes.switchToStatusInfo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [],
    },
    submitButtonLabel: {
      name: 'submitButtonLabel',
      label: 'entities:availabilityStatusTenantSettings.attributes.submitButtonLabel.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      maxLength: 15,
      validationType: 'string',
      validations: [],
    },
  },
}

export default availabilityStatusTenantSettingsModel
